<template>
  <q-dialog
    :model-value="offline"
    no-backdrop-dismiss
    no-esc-dismiss
    no-route-dismiss
  >
    <q-card class="text-center bg-white">
      <q-card-section>
        <div class="text-h1">
          <q-icon name="mdi-cloud-off-outline" />
        </div>
        <template v-if="!checkingConnection">
          <div class="text-h6">
            You are offline
          </div>
          <div class="q-mt-xs">
            Please check your internet connection and try again.
          </div>
        </template>
        <template v-else>
          <div class="text-h6">
            Checking your connection...
          </div>
        </template>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { Network } from '@capacitor/network'
/**
 * Run checks to see if the user is offline
 */
export default {
  emits: ['ready'],
  data () {
    return {
      initiallyOffline: false,
      checkingConnection: false,
      offline: !!this.$q.platform.is.capacitor
    }
  },
  methods: {
    async runCheck () {
      const status = await Network.getStatus()

      if (status.connectionType === 'none') {
        this.offlineListener()
      }
      else {
        this.onlineListener()
      }
    },
    offlineListener () {
      this.offline = true
    },
    onlineListener () {
      if (this.initiallyOffline) {
        this.checkingConnection = true
        setTimeout(() => {
          window.location.reload()
        }, 5000)
      }
      else {
        this.offline = false
        this.$emit('ready')
      }
    },
    createListener () {
      Network.addListener('networkStatusChange', status => {
        if (status.connectionType === 'none') {
          this.offlineListener()
        }
        else {
          this.onlineListener()
        }
      })
    },
    async checkNetwork () {
      if (!this.$q.platform.is.capacitor) {
        this.$emit('ready')
        return
      }

      const status = await Network.getStatus()
      this.initiallyOffline = status.connectionType === 'none'
      await this.runCheck()

      this.createListener()

      document.addEventListener('pause', () => {
        Network.removeAllListeners()
      }, false)

      document.addEventListener('resume', () => {
        this.createListener()
        /* When they resume the app, check that they are still connected */
        this.runCheck()
      }, false)
    }
  },
  created () {
    this.$nextTick(() => {
      this.checkNetwork()
    })
  },
  beforeUnmount () {
    if (this.$q.platform.is.capacitor) {
      Network.removeAllListeners()
    }
  }
}
</script>
